module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="trans-' +
((__t = ( className().replace('_svg','') )) == null ? '' : __t) +
' arrow arrow-bottom">\n  <div class="widget-popover fade in bottom arrow arrow-bottom">\n    <div class="widget-popover-title">\n        <span>' +
((__t = ( src.get("code").slice(2) )) == null ? '' : __t) +
'</span>\n        <h2 class="item-title">' +
((__t = ( src.get("title") )) == null ? '' : __t) +
'</h2>\n    </div>\n    <div class="widget-popover-content">\n      <div class="widget-popover-sums">\n          <span class="approved">\n              ' +
((__t = ( format_full_number( rev*1000 ) )) == null ? '' : __t) +
' ₪\n          </span>\n          <span class="percentage">\n              ' +
((__t = ( 
                orig > 0 ? (Math.abs( rev / orig ) * 100).toFixed(0) + "%" : ""
              )) == null ? '' : __t) +
'\n          </span>\n        </div>\n        <p class="description">\n        ' +
((__t = ( src.get('explanation') == null? "" : src.get('explanation') )) == null ? '' : __t) +
'\n        </p>\n        <span class="history increased">\n        ';
 var styc = src.get('astyc'); ;
__p += '\n        ';
 if (styc != null ) { ;
__p += '\n            ';
 if (styc > 0) { ;
__p += '\n              מ-2009 גדל התקציב בממוצע מדי שנה בכ-' +
((__t = ( styc )) == null ? '' : __t) +
'%\n              ';
 } ;
__p += '\n              ';
 if (styc < 0) { ;
__p += '\n              מ-2009 ' +
((__t = ( -styc )) == null ? '' : __t) +
'% מהתקציב בממוצע מועבר למטרות אחרות\n            ';
 } ;
__p += '\n        ';
 } ;
__p += '\n        </span>\n    </div>\n  </div>\n</div>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/bubble-tooltip.html
// module id = 134
// module chunks = 0